import React, { useState } from 'react';
import { D20Icon } from '../primitives/icons';

export const CalmToolRow = ({ tool, palette, bodyFont, c }) => {
  const [hover, setHover] = useState(false);
  return (
    <button
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={tool.onClick}
      disabled={!tool.onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '12px 14px',
        background: hover ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.03)',
        border: `1px solid ${hover ? `${palette.color}55` : 'rgba(255,255,255,0.10)'}`,
        borderRadius: 6,
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'all 120ms ease',
        width: '100%',
        fontFamily: bodyFont,
      }}
    >
      {typeof tool.icon === 'string' ? (
        <span style={{
          width: 40, height: 40,
          borderRadius: 6,
          background: `${palette.color}1c`,
          border: `1px solid ${palette.color}55`,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '1.1rem',
          color: palette.light,
          flex: '0 0 40px',
        }}>{tool.icon}</span>
      ) : (
        <span style={{
          width: 40, height: 40,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          flex: '0 0 40px',
        }}>
          {tool.key === 'dice' ? <D20Icon size={32} /> : tool.icon}
        </span>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontFamily: bodyFont,
          fontSize: '0.92rem',
          fontWeight: 600,
          color: c.textPrimary,
          marginBottom: 2,
        }}>{tool.label}</div>
        <div style={{
          fontFamily: bodyFont,
          fontSize: '0.78rem',
          color: c.textMuted,
        }}>{tool.sub}</div>
      </div>
      <span style={{
        color: hover ? palette.light : c.textMuted,
        fontSize: '1.1rem',
        transition: 'color 120ms ease',
      }}>→</span>
    </button>
  );
};
